import { COMPANY, COMPANY_FACTS, IMAGES } from "@/data/content";
import { Eyebrow, MaskedLines, Reveal } from "./shared";

export default function CompanyProfile() {
  return (
    <section
      id="company"
      data-testid="company-section"
      className="relative overflow-hidden bg-navy py-28 text-white md:py-40"
    >
      {/* orbital decorative arcs inspired by the brand symbol */}
      <svg
        aria-hidden="true"
        viewBox="0 0 900 900"
        className="pointer-events-none absolute -right-64 -top-64 h-[52rem] w-[52rem]"
      >
        <g fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="1">
          <circle cx="450" cy="450" r="430" />
          <circle cx="450" cy="450" r="330" />
          <circle cx="450" cy="450" r="230" />
          <path d="M60 480 C 260 330, 640 330, 840 470" stroke="rgba(22,135,217,0.25)" />
        </g>
      </svg>

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid items-center gap-16 lg:grid-cols-2 lg:gap-24">
          <div>
            <Eyebrow light>Company Profile</Eyebrow>
            <h2 className="mt-7 font-serif font-medium leading-[1.02] tracking-tight">
              <MaskedLines
                lines={[
                  <span key="a" style={{ fontSize: "clamp(2.4rem, 5vw, 4.8rem)" }} className="block">
                    OSWAL COSLABS
                  </span>,
                  <span
                    key="b"
                    style={{ fontSize: "clamp(2.4rem, 5vw, 4.8rem)" }}
                    className="block font-normal italic text-brand-bright"
                  >
                    Private Limited
                  </span>,
                ]}
              />
            </h2>

            <Reveal delay={0.25}>
              <p className="mt-9 max-w-md text-base leading-relaxed text-white/65">
                {COMPANY.description}
              </p>
            </Reveal>

            <Reveal delay={0.3} className="mt-12">
              <dl>
                {COMPANY_FACTS.map((fact) => (
                  <div
                    key={fact.label}
                    className="grid grid-cols-3 items-baseline gap-4 border-t border-white/12 py-5 last:border-b"
                  >
                    <dt className="text-[11px] font-semibold uppercase tracking-[0.26em] text-white/45">
                      {fact.label}
                    </dt>
                    <dd className="col-span-2 text-[15px] font-medium text-white/90">
                      {fact.value}
                    </dd>
                  </div>
                ))}
              </dl>
            </Reveal>
          </div>

          <Reveal delay={0.15} y={44}>
            <div className="relative" data-testid="company-image">
              <div
                aria-hidden="true"
                className="absolute -left-4 -top-4 h-full w-full border border-brand-bright/30"
              />
              <div className="img-grade relative aspect-[4/5] overflow-hidden">
                <img
                  src={IMAGES.company}
                  alt="A care professional applying a facial treatment with a brush"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
                <svg
                  aria-hidden="true"
                  viewBox="0 0 200 200"
                  className="absolute inset-0 h-full w-full"
                  preserveAspectRatio="xMidYMid slice"
                >
                  <g fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="0.6">
                    <circle cx="150" cy="52" r="18" />
                    <circle cx="150" cy="52" r="34" />
                    <circle cx="150" cy="52" r="52" />
                    <path d="M150 0 V200 M0 52 H200" strokeDasharray="3 5" />
                  </g>
                  <circle cx="150" cy="52" r="3.5" fill="#1687D9" />
                </svg>
              </div>
              <div className="mt-5 flex items-baseline justify-between">
                <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-white/50">
                  Head Office — Ellis Bridge, Ahmedabad
                </p>
                <p className="font-serif text-sm italic text-white/50">
                  23.03° N, 72.58° E
                </p>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
